import { render, staticRenderFns } from "./ECommerceBasicData.vue?vue&type=template&id=56d1006f&scoped=true&"
import script from "./ECommerceBasicData.vue?vue&type=script&lang=js&"
export * from "./ECommerceBasicData.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceBasicData.vue?vue&type=style&index=0&id=56d1006f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1006f",
  null
  
)

export default component.exports